var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects"},_vm._l((_vm.projects),function(project){return _c('router-link',{key:project,attrs:{"to":project}},[_c('div',{staticClass:"btn",class:[ _vm.$route.params.project === project ? 'btn-active' : '' ]},[_vm._v(_vm._s(project))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }